export interface HumanChatCommandRetry {
  action: 'customer-cancel' | 'customer-end';
  commandId: string;
  conversationId: string;
  epoch: number;
}

export function isHumanChatCommandRetries(value: unknown): value is HumanChatCommandRetry[] {
  return Array.isArray(value) && value.length <= 2 && value.every(command => command
    && ['customer-cancel', 'customer-end'].includes(command.action)
    && typeof command.commandId === 'string' && command.commandId.length > 0 && command.commandId.length <= 200
    && typeof command.conversationId === 'string' && command.conversationId.length > 0 && command.conversationId.length <= 200
    && Number.isSafeInteger(command.epoch) && command.epoch >= 0)
    && new Set(value.map(command => command.commandId)).size === value.length
    && new Set(value.map(command => command.action)).size === value.length;
}